import { getContext } from '@fiverr-private/fiverr_context';
import { BUSINESS_TYPES } from '../../constants';

export const getProgram = (type) => {
    switch (type) {
        case BUSINESS_TYPES.strategic:
            return 1;
        case BUSINESS_TYPES.classic:
            return 2;
        default:
            return 3;
    }
};

export const getBaseBqFields = () => {
    const { organizationId, userId, userGuid } = getContext();

    return {
        sub_group: 'fiverr_pro',
        feature: {
            name: 'fiverr_pro',
        },
        uid: userGuid,
        user: {
            id: userId,
        },
        organization: {
            id: organizationId,
        },
        business_account: {
            team: {
                id: organizationId,
            },
            owner_user_id: userId,
        },
    };
};

export const getBaseClickBqFields = () => ({
    ...getBaseBqFields(),
    group: 'user_action',
    action: {
        type: 'click',
    },
});
